<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">

        <a-form-model-item
            prop="dictName"
          label="字典名称">
          <a-input placeholder="请输入字典名称" v-model="model.dictName" />
        </a-form-model-item>
        <a-form-model-item
            prop="description"
          label="描述">
          <a-input placeholder="请输入描述" v-model="model.description" />
        </a-form-model-item>
        <a-form-model-item
            prop="type"
          label="类型">
          <a-radio-group v-model="model.type" >
            <a-radio value="1">字符</a-radio>
            <a-radio value="2">数字</a-radio>
          </a-radio-group>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'

  export default {
    name: "ProjectDictModal",
    props:{
      projectId:{
        type:String,
        default:''
      }
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{
          dictName:[baseRules.required],
        },
        confirmLoading: false,

        url: {
          add: "/project/projectDict/add",
          edit: "/project/projectDict/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({
          type:'1',
          projectId: this.projectId,
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>